import React, { useEffect } from 'react'

import { useBanner } from 'containers/Banner'

import {
  PersonalWorkspaceBanner,
  UPGRADE_PERSONAL_WORKSPACE_BANNER_ID,
} from './Banners'
import { WorkspaceMinimalFragment } from 'gqlTypes'

type WorkspaceType = WorkspaceMinimalFragment['type']

interface PersonalWorkspaceBannersProps {
  workspaceId: string
  workspaceType: WorkspaceType
  isOwner: boolean
}

export const PersonalWorkspaceBanners: React.FC<PersonalWorkspaceBannersProps> = props => {
  const { workspaceId, workspaceType, isOwner } = props
  const { showBanner } = useBanner()

  useEffect(() => {
    if (workspaceType === 'PERSONAL' && isOwner) {
      const banner = showBanner({
        id: UPGRADE_PERSONAL_WORKSPACE_BANNER_ID,
        message: <PersonalWorkspaceBanner workspaceId={workspaceId} />,
        type: 'warning',
      })

      return () => {
        banner?.dismissBanner()
      }
    }
  }, [showBanner, workspaceId, workspaceType, isOwner])

  return null
}
